import React from 'react';
import { MultiSelect } from 'primereact/multiselect';
import { ColumnsSelectorWrapper } from './common';

interface ColumnSelectorProps {
  // The full set of columns
  options: any[];
  // The columns that are currently hidden
  value: any[];
  onChange: (fields: string[]) => void;
  placeholder?: string;
  optionLabel?: string;
}

export const ColumnSelector: React.FC<ColumnSelectorProps> = ({
  options,
  value,
  onChange,
  placeholder = 'Select Columns to Hide',
  optionLabel = 'header',
}) => {
  const handleMultiSelectChange = (e: any) => {
    const newHiddenFields = e.value.map((col: any) => col.field);
    onChange(newHiddenFields);
  };

  return (
    <ColumnsSelectorWrapper>
      <MultiSelect
        value={value}           // column objects that are hidden
        options={options}       // all columns for the current category
        onChange={handleMultiSelectChange}
        optionLabel={optionLabel}
        display="chip"
        placeholder={placeholder}
      />
    </ColumnsSelectorWrapper>
  );
};

export default ColumnSelector;
